<template>
  <div class="species-navigation-pane">
    <div>
      <el-button type="success" style="margin: 20px 0px 10px 0px;" @click="showSpeciesTable">Open Species Table</el-button>
      <div style="margin-bottom: 10px;">OR</div>
      <el-autocomplete popper-class="species-autocomplete" v-model="searchString" :fetch-suggestions="getSuggestions" @select="handleSelect" placeholder="Add species by name...">
        <template slot-scope="{ item }">
          <div class="value">{{ item.value }}</div>
          <div class="id">{{ item.build }} - {{ item.MSDBID }}</div>
        </template>
      </el-autocomplete>
    </div>
    <el-divider></el-divider>
    <div style="margin-top: 20px">
      <h3>Selected species ({{ store.species.order.length }})</h3>
    </div>
    <div style="max-height: 50vh; overflow-y: auto">
      <species-navigation-item v-for="(id, index) in store.species.order" :key="id" :id="id" :index="index + 1"></species-navigation-item>
    </div>
    <el-divider></el-divider>
    <el-row>
        <el-button @click="moveSpeciesUp">Move Up</el-button>
        <el-button @click="moveSpeciesDown">Move Down</el-button>
    </el-row>
  </div>
</template>

<script>
import { store } from '../scripts/store.js'
import { events } from '../scripts/events.js'
import SpeciesNavigationItem from './SpeciesNavigationItem.vue'

const _ = require('lodash')

export default {
  name: 'SpeciesNavigationPane',
  components: {
    SpeciesNavigationItem
  },
  data () {
    return {
      store: store,
      searchString: '',
      autocompleteOptions: []
    }
  },
  mounted () {
    this.autocompleteOptions = this.loadSuggestions()
  },
  methods: {
    getSuggestions (string, callback) {
      if (string.length < 3) {
        return
      }
      const results = this.autocompleteOptions.filter(o => {
        return o.value.toLowerCase().startsWith(string.toLowerCase()) ||
        o.common.toLowerCase().startsWith(string.toLowerCase()) ||
        o.common.toLowerCase().includes(string.toLowerCase())
      })
      callback(results)
    },
    loadSuggestions () {
      const options = _.map(store.species.list, s => {
        return {
          MSDBID: s.MSDBID,
          value: s.OrganismName,
          common: s.CommonName,
          build: s.Build
        }
      })
      return options
    },
    handleSelect (species) {
      if (this.store.species.order.includes(species.MSDBID)) {
        events.$message({
          message: 'Genome already in selected list',
          type: 'warning'
        })
      } else { 
        store.addSpecies(_.find(store.species.list, s => {
          return s.MSDBID === species.MSDBID
        }), 'Autocomplete Search Box')
      }
    },
    moveSpeciesUp () {
      const currentIndex = store.species.order.indexOf(store.species.current)
      if (currentIndex === 0) {
        return
      } else {
        store.exchangeOrder(currentIndex, currentIndex - 1)
      }
    },
    moveSpeciesDown () {
      const currentIndex = store.species.order.indexOf(store.species.current)
      if (currentIndex === store.species.order.length - 1) {
        return
      } else {
        store.exchangeOrder(currentIndex, currentIndex + 1)
      }
    },
    showSpeciesTable () {
      events.$emit('show-species-table')
    }
  }
}
</script>

<style scoped>
.species-autocomplete div.value {
  font-size: 1.1em;
}

.species-autocomplete div.id {
  font-size: 0.8em;
  padding-bottom: 5px;
  border-bottom: 1px solid lightgrey; 
}
</style>

